import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import translationEN from './locales/en.json';
import translationES from './locales/es.json';
import translationPR from './locales/pr.json';

const resources = {
	en: {translation: translationEN},
	es: {translation: translationES},
	pr: {translation: translationPR}
};

i18n
	// Detect user language
	// Ref: https://github.com/i18next/i18next-browser-languageDetector
	.use(LanguageDetector)
	// // Pass the i18n instance to react-i18next
	.use(initReactI18next)
	// Init i18next
	// Ref: https://www.i18next.com/overview/configuration-options
	.init({
		resources,
		fallbackLng: 'es',
		debug: false,
		load: 'all',
		nonExplicitSupportedLngs: true,
		interpolation: {
			escapeValue: false, // not needed for react as it escapes by default
		}
	});

export default i18n;